import Apicall from "../api/Apicall";
import { Context } from "../components/containers/context/Context";
import {useContext} from "react";


export const useServicios= ({app}) => {

    const {user} = useContext(Context);

    const consultarServiciosAdministrador = async ({setData}) => {

        try{
            const result = await Apicall({
                url: `${app.url}/user/getServiciosAdministrador`, user, app      
            });

            if(result?.data?.success === true && result?.data?.data && setData) {
                setData(result.data.data);
            } else {
                setData([]);
            }

        } catch(e){
            setData([]);
        }

    }

    return {
        consultarServiciosAdministrador
    };

}